const initialCamera = {
  radar: false,
  crossroad: false,
  perimeter: false
  // video: false
}

const camera = (state = initialCamera, action) => {
  switch (action.type) {
    case "RADAR":
      return { ...state, radar: action.val }
    case "CROSSROAD":
      return { ...state, crossroad: action.val }
    case "PERIMETER":
      return { ...state, perimeter: action.val }
    // case "VIDEO":
    //   return { ...state, video: action.val }
    default:
      return state
  }
}

export default camera
